const PreviewSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_5099_23574)">
        <path
          d="M14 6.4989C14 6.4989 11.2449 10 8.0971 10C4.94932 10 2 6.56496 2 6.56496C2 6.56496 4.94932 3 8.0971 3C11.2449 3 14 6.4989 14 6.4989Z"
          stroke="#333333"
          strokeWidth="1.1"
          strokeMiterlimit="10"
        />
        <path
          d="M8 8C8.82843 8 9.5 7.32843 9.5 6.5C9.5 5.67157 8.82843 5 8 5C7.17157 5 6.5 5.67157 6.5 6.5C6.5 7.32843 7.17157 8 8 8Z"
          stroke="#333333"
          strokeWidth="1.1"
          strokeMiterlimit="10"
        />
        <path
          d="M3 13H13"
          stroke="#333333"
          strokeWidth="1.1"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5099_23574">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PreviewSvg;
